import { IReduxState } from "app/api/types";
import { ADD_ALBUM, ADD_RESOURCE, GET_ALBUMS, DELETE_RESOURCE, DELETE_ALBUM, SET_PROGRESS } from './actions';
import { Album } from 'app/api/types';

type IState = { albums: Array<Album>, progress: number } & IReduxState;

const initialState: IState = {
	isLoading: false,
	progress: 0,
	albums: [],
};

const galleryReducer = (
	state = initialState,
	action: { type: string; payload: any }
) => {
	switch (action.type) {
		case SET_PROGRESS:
			return { ...state, progress: action.payload };
		case GET_ALBUMS:
			return {
				...state,
				progress: 0,
				albums: action.payload,
			}
		case DELETE_ALBUM:
			return {
				...state,
				albums: state.albums.filter(x => x.id !== action.payload),
			};
		case ADD_ALBUM:
			const existAlbum = state.albums.find(x => x.id === action.payload.id);
			if (existAlbum) {
				Object.assign(existAlbum, action.payload);
				return { ...state }
			}
			return {
				...state,
				albums: [...state.albums, action.payload],
			}
		case ADD_RESOURCE: {
			const album = state.albums.find(x => x.id === action.payload.albumId);
			if (album) album.resources.push(action.payload.resource);
			return { ...state, progress: 1 }
		}
		case DELETE_RESOURCE: {
			const album = state.albums.find(x => x.id === action.payload.albumId);
			if (album) album.resources = album.resources.filter(x => x.id !== action.payload.id);
			return { ...state }
		}
		default:
			return state;
	}
}

export default galleryReducer;
